export const version = "1.7.20";
export const channel = "core";
export const gitcommit = "unknown";
